<script>
import Edit from "@/resources/auction/Edit";

export default {
    extends: Edit
};
</script>
